import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var questionListRes;
export const questionListTodo = createAsyncThunk('questionList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'quiz/view_question_list',
            data: {
                "user_id": user_id.vemp_code,
                "dept_id": data.department,
                "status": data.status,
                "temp": data.temp,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return questionListRes = res.data
    } catch (error) {
        return questionListRes = error.response.data
    }
})


const questionListSlice = createSlice({
    name: 'questionList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(questionListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('questionList', state.data)
            }
        });
        builder.addCase(questionListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default questionListSlice.reducer; 